import React, { useMemo } from 'react';

import { CardMetadata, type CardMetadataItem } from '../../../common/ui/Card/CardMetadata';
import type { AgentCardAgent } from '../types';

export type AgentMetadataProps = {
	agent: AgentCardAgent;
	testId?: string;
};

export const AgentMetadata = ({ agent, testId }: AgentMetadataProps): React.JSX.Element => {
	const metadataItems = useMemo(
		() =>
			[
				agent.creatorName && {
					key: 'creator',
					label: agent.creatorName,
				},
			].filter(Boolean),
		[agent],
	);

	return <CardMetadata items={metadataItems as CardMetadataItem[]} testId={testId} />;
};
